<div *ngIf="!isStripeLoaded" class="mt-5 d-flex justify-content-center">
  <div>
    <img class="logo tw-mb-4" alt="Gloss" />
    <p class="tw-text-center">
      <i
        class="bwi bwi-spinner bwi-spin bwi-2x tw-text-muted"
        title="Loading"
        aria-hidden="true"
      ></i>
    </p>
  </div>
</div>
<ng-container *ngIf="isStripeLoaded">
  <div
    class="tw-min-w-xl tw-mx-auto tw-max-w-xl tw-rounded-3xl tw-bg-color-surface-card tw-px-4 tw-pt-8 tw-pb-2 tw-shadow-elevation-card"
  >
    <p
      class="tw-text-center tw-px-8 tw-font-medium tw-text-sm tw-text-color-text-secondary sm:tw-m-0"
    >
      {{ "registerAccount" | i18n }}
    </p>
    <div class="tw-px-10 tw-py-6 sm:tw-px-4">
      <form
        #form
        [appApiAction]="formPromise"
        class="tw-container tw-mx-auto"
        [formGroup]="formGroup"
      >
        <div class="tw-flex tw-flex-col">
          <bit-form-field>
            <bit-label
              class="tw-font-semibold tw-text-sm tw-text-color-text-tertiary sm:tw-text-xs"
              >{{ "emailAddress" | i18n }}</bit-label
            >
            <div class="tw-relative tw-w-full">
              <div
                class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-pointer-events-none"
              >
                <icon [name]="'mail'" [size]="5" class="tw-mr-2 tw-text-color-text-tertiary"></icon>
              </div>
              <input
                id="register-form_input_email"
                bitInput
                autocomplete="email"
                type="email"
                formControlName="email"
                placeholder="{{ 'emailAddress' | i18n }}"
                class="tw-bg-color-surface-input tw-shadow-neuomorphic-inset placeholder:tw-text-color-text-tertiary tw-font-normal tw-text-xs tw-pl-10"
              />
            </div>
          </bit-form-field>

          <div>
            <bit-form-field>
              <bit-label
                class="tw-font-semibold tw-text-sm tw-text-color-text-tertiary sm:tw-text-xs"
                >{{ "name" | i18n }}</bit-label
              >
              <div class="tw-relative tw-w-full">
                <div
                  class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-pointer-events-none"
                >
                  <icon
                    [name]="'user'"
                    [size]="5"
                    class="tw-mr-2 tw-text-color-text-tertiary"
                  ></icon>
                </div>
                <input
                  id="register-form_input_name"
                  bitInput
                  type="text"
                  formControlName="name"
                  placeholder="{{ 'enterPreferredName' | i18n }}"
                  class="tw-bg-color-surface-input tw-shadow-neuomorphic-inset placeholder:tw-text-color-text-tertiary tw-font-normal tw-text-xs tw-pl-10"
                />
              </div>
            </bit-form-field>
          </div>

          <app-callout-bw
            type="info"
            [enforcedPolicyOptions]="enforcedPolicyOptions"
            *ngIf="enforcedPolicyOptions"
          >
          </app-callout-bw>
          <bit-form-field class="!tw-mb-1">
            <bit-label
              class="tw-font-semibold tw-text-sm tw-text-color-text-tertiary sm:tw-text-xs"
              >{{ "masterPass" | i18n }}</bit-label
            >
            <div class="tw-relative tw-w-full tw-mb-2">
              <div
                class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-pointer-events-none"
              >
                <icon
                  [name]="'lock-03'"
                  [size]="5"
                  class="tw-mr-2 tw-text-color-text-tertiary"
                ></icon>
              </div>
              <input
                id="register-form_input_master-password"
                bitInput
                type="password"
                autocomplete="new-password"
                formControlName="masterPassword"
                placeholder="{{ 'enterPassword' | i18n }}"
                class="tw-w-full tw-pr-12 tw-bg-color-surface-input tw-shadow-neuomorphic-inset tw-text-color-text-tertiary tw-font-normal tw-text-xs tw-pl-10"
              />
            </div>
            <button
              type="button"
              bitSuffix
              bitPasswordInputToggle
              [(toggled)]="showPassword"
              class="tw-h-full tw-bg-transparent"
            >
              <svg class="tw-h-6 tw-w-6 tw-opacity-60 tw-text-color-icon-secondary">
                <use
                  [attr.xlink:href]="'images/sprite.svg#' + (showPassword ? 'eye' : 'eye-off')"
                ></use>
              </svg>
            </button>
          </bit-form-field>
          <div
            class="tw-flex tw-rounded-lg tw-bg-color-surface-input tw-p-3 tw-mt-1"
            [ngClass]="{
              'tw-border tw-border-solid tw-border-dt-border-error': isPassWordInlineInvalid(),
            }"
          >
            <app-checkbox
              id="register_declaration"
              [customisedBoxSize]="'5'"
              [checked]="formGroup.get('passwordDeclaration').value"
              (onChange)="onCheckboxChange($event)"
              class="tw-cursor-pointer tw-border-2 tw-w-5 tw-h-5 tw-rounded-md tw-mr-4"
              [ngClass]="{
                'tw-border-transparent': !isCheckboxInvalid,
                'tw-border-transparent !tw-outline !tw-outline-2 !tw-outline-danger tw-flex tw-items-center':
                  isCheckboxInvalid,
              }"
            ></app-checkbox>
            <div class="tw-w-full">
              <div
                class="tw-block tw-w-full tw-bg-color-surface-input tw-rounded-xl tw-items-center"
              >
                <span class="tw-flex tw-items-center tw-justify-center">
                  <icon
                    [name]="'alert-circle'"
                    [size]="5"
                    class="tw-mr-2 tw-text-color-status-warning-solid"
                  ></icon>
                  <span class="tw-font-medium tw-text-xs tw-text-color-status-warning-solid">{{
                    "encryptAcknowledgment" | i18n
                  }}</span>
                </span>
                <ng-container *ngIf="formGroup.get('passwordDeclaration').value">
                  <button
                    type="button"
                    aria-haspopup="dialog"
                    [attr.aria-expanded]="tooltip.showHelpTooltip"
                    class="tw-block tw-mt-1 tw-w-full tw-p-0 tw-text-left tw-text-dt-text-warning tw-cursor-pointer"
                    (click)="tooltip.show($event)"
                  >
                    <span class="tw-text-color-text-tertiary tw-font-medium tw-text-xs">{{
                      "acknowledgmentDesc" | i18n
                    }}</span>
                    <span
                      class="tw-font-bold tw-text-xs tw-underline tw-text-color-status-warning-solid"
                      >{{ "learnMore" | i18n }}</span
                    >
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
          @if (tooltip.showHelpTooltip) {
            <div class="tw-fixed tw-inset-0 tw-z-40">
              <div
                class="tw-absolute tw-w-full tw-h-full tw-z-40 tw-bg-black tw-opacity-60"
                (click)="tooltip.close()"
              ></div>
              <div class="tw-w-full tw-h-full tw-flex tw-z-30 tw-items-center tw-justify-center">
                <div
                  role="dialog"
                  aria-modal="true"
                  [attr.aria-label]="'importantNotePassword' | i18n"
                  cdkTrapFocus
                  cdkTrapFocusAutoCapture
                  class="glass-dialog-surface tw-p-6 tw-absolute tw-z-50 tw-w-[400px] tw-max-w-[90vw] tw-max-h-[90dvh]"
                >
                  <button
                    type="button"
                    [attr.aria-label]="'close' | i18n"
                    class="glass-dialog__close-btn tw-absolute tw-top-3 tw-right-4 tw-opacity-60 tw-p-2"
                    (click)="tooltip.close()"
                  >
                    <icon [name]="'close'" [size]="8"></icon>
                  </button>
                  <div class="tw-pr-8">
                    <ng-container *ngTemplateOutlet="importantNotePassword"></ng-container>
                  </div>
                </div>
              </div>
            </div>
          }
          <app-password-strength
            class="tw-h-auto sm:tw-h-4"
            [password]="formGroup.get('masterPassword')?.value"
            [email]="formGroup.get('email')?.value"
            [name]="formGroup.get('name')?.value"
            [showText]="true"
            (passwordStrengthResult)="getStrengthResult($event)"
          >
          </app-password-strength>

          <bit-form-field>
            <bit-label
              class="tw-font-semibold tw-text-sm tw-text-color-text-tertiary sm:tw-text-xs"
              >{{ "reTypeMasterPass" | i18n }}</bit-label
            >
            <div class="tw-relative tw-w-full">
              <div
                class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-pointer-events-none"
              >
                <icon
                  [name]="'lock-03'"
                  [size]="5"
                  class="tw-mr-2 tw-text-color-text-tertiary"
                ></icon>
              </div>
              <input
                id="register-form_input_confirm-master-password"
                bitInput
                autocomplete="new-password"
                type="password"
                formControlName="confirmMasterPassword"
                placeholder="{{ 'retypePassword' | i18n }}"
                class="tw-w-full tw-pr-12 tw-bg-color-surface-input tw-shadow-neuomorphic-inset tw-text-color-text-tertiary tw-font-normal tw-text-xs tw-pl-10"
              />
            </div>
            <button
              type="button"
              bitSuffix
              bitPasswordInputToggle
              [(toggled)]="showPassword"
              class="tw-h-full tw-bg-transparent"
            >
              <svg class="tw-h-6 tw-w-6 tw-opacity-60 tw-text-color-icon-secondary">
                <use
                  [attr.xlink:href]="'images/sprite.svg#' + (showPassword ? 'eye' : 'eye-off')"
                ></use>
              </svg>
            </button>
          </bit-form-field>

          <button
            *ngIf="!showHintInput"
            type="button"
            [attr.aria-expanded]="showHintInput"
            class="tw-w-full tw-h-12 tw-bg-color-surface-card tw-shadow-neuomorphic-card tw-rounded-lg tw-flex tw-items-center tw-px-2 tw-justify-between"
            (click)="showHintInput = true"
          >
            <span class="tw-font-medium tw-text-xs tw-text-dt-text-headings">{{
              "addPasswordHint" | i18n
            }}</span>
            <icon [name]="'book'" [size]="6" class="tw-text-color-text-tertiary"></icon>
          </button>
          <div
            *ngIf="showHintInput"
            class="tw-flex tw-flex-col tw-w-full tw-bg-color-surface-input tw-rounded-xl tw-p-4 tw-gap-4"
          >
            <button
              type="button"
              [attr.aria-expanded]="showHintInput"
              class="tw-flex tw-w-full tw-items-center tw-justify-between tw-bg-transparent"
              (click)="hideHintInput()"
            >
              <span class="tw-font-medium tw-text-xs tw-text-dt-text-headings">{{
                "addPasswordHint" | i18n
              }}</span>
              <icon [name]="'book'" [size]="6" class="tw-ml-2 tw-text-color-text-tertiary"></icon>
            </button>
            <bit-form-field>
              <bit-label class="tw-sr-only" for="register-form_input_hint">{{
                "addPasswordHint" | i18n
              }}</bit-label>
              <input
                id="register-form_input_hint"
                bitInput
                type="text"
                formControlName="hint"
                placeholder="{{ 'enterPasswordHint' | i18n }}"
                class="tw-bg-color-surface-input tw-shadow-neuomorphic-inset placeholder:tw-text-color-text-tertiary tw-font-normal tw-text-xs tw-pl-3"
              />
              <bit-hint>{{ "masterPassHintDesc" | i18n }}</bit-hint>
            </bit-form-field>
          </div>

          <button
            *ngIf="!showReferralInput"
            type="button"
            [attr.aria-expanded]="showReferralInput"
            class="tw-w-full tw-h-12 tw-bg-color-surface-card tw-shadow-neuomorphic-card tw-rounded-lg tw-flex tw-items-center tw-px-2 tw-justify-between tw-mt-6"
            (click)="showReferralInput = true"
          >
            <span class="tw-font-medium tw-text-xs tw-text-dt-text-headings">{{
              "addReferralCode" | i18n
            }}</span>
            <icon [name]="'add-person'" [size]="6" class="tw-text-color-text-tertiary"></icon>
          </button>
          <div
            *ngIf="showReferralInput"
            class="tw-flex tw-flex-col tw-w-full tw-bg-color-surface-input tw-rounded-xl tw-p-4 tw-gap-4 tw-mt-6"
          >
            <button
              type="button"
              [attr.aria-expanded]="showReferralInput"
              class="tw-flex tw-w-full tw-items-center tw-justify-between tw-bg-transparent"
              (click)="hideReferralInput()"
            >
              <span class="tw-font-medium tw-text-xs tw-text-dt-text-headings">{{
                "addReferralCode" | i18n
              }}</span>
              <icon
                [name]="'add-person'"
                [size]="6"
                class="tw-ml-2 tw-text-color-text-tertiary"
              ></icon>
            </button>
            <bit-form-field>
              <bit-label
                class="tw-font-semibold tw-text-sm tw-text-color-text-tertiary sm:tw-text-xs"
                for="register-form_input_referral-code"
                >{{ "referralCode" | i18n }}</bit-label
              >
              <div
                class="tw-relative tw-w-full tw-rounded-lg"
                [style.box-shadow]="
                  referralCodeStatus === 'invalid'
                    ? '0 0 0 2px var(--color-status-error-solid)'
                    : null
                "
              >
                <icon
                  class="tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-z-10 tw-pointer-events-none"
                  [name]="'add-person'"
                  [size]="6"
                  [currentColor]="'color-icon-secondary'"
                ></icon>
                <input
                  id="register-form_input_referral-code"
                  bitInput
                  type="text"
                  class="!tw-pl-11 tw-bg-color-surface-input placeholder:tw-indent-10"
                  [class.!tw-border-transparent]="referralCodeStatus === 'invalid'"
                  [style.box-shadow]="referralCodeStatus === 'invalid' ? 'none' : null"
                  formControlName="referralCode"
                  placeholder="{{ 'enterReferralCode' | i18n }}"
                  (input)="onReferralCodeInput()"
                  (blur)="onReferralCodeBlur()"
                />
              </div>
              <bit-hint
                [class.!tw-hidden]="referralCodeStatus !== 'checking'"
                class="tw-text-xs !tw-text-color-text-tertiary"
                >{{ "referralCodeChecking" | i18n }}</bit-hint
              >
              <bit-hint
                [class.!tw-hidden]="referralCodeStatus !== 'invalid'"
                class="tw-text-xs !tw-text-color-status-error-text tw-font-medium"
                >{{ "referralCodeInvalid" | i18n }}</bit-hint
              >
              <bit-hint
                [class.!tw-hidden]="referralCodeStatus !== 'valid'"
                class="tw-text-xs !tw-text-color-status-success-text tw-font-medium"
                >{{ "referralCodeValid" | i18n }}</bit-hint
              >
              <bit-hint
                [class.!tw-hidden]="referralCodeStatus !== 'error'"
                class="tw-text-xs !tw-text-color-status-error-text tw-font-medium"
                >{{ "referralCodeApiError" | i18n }}</bit-hint
              >
            </bit-form-field>
          </div>

          <div [hidden]="!showCaptcha()">
            <iframe id="hcaptcha_iframe" height="80"></iframe>
          </div>

          <ng-container *ngIf="!accountCreated">
            <a
              [routerLink]="'/#/login'"
              class="tw-underline tw-text-center !tw-text-dt-text-headings tw-my-3 tw-font-medium tw-text-xs"
              >{{ "backToLogin" | i18n }}</a
            >
            <app-gloss-button
              class="tw-w-full"
              [options]="{
                type: 'submit',
                fullClass: 'tw-bg-color-action-primary tw-h-12 tw-w-full tw-px-6 tw-rounded-full ',
                text: 'createAccount' | i18n,
                onClick: submit.bind(this),
                isEnabled: !isBusy,
              }"
              fontClass="!tw-font-bold tw-text-base tw-text-color-text-on-action"
              [isLoading]="isLoading"
            >
            </app-gloss-button>
          </ng-container>
          <bit-error-summary *ngIf="showErrorSummary" [formGroup]="formGroup"></bit-error-summary>
        </div>
      </form>
    </div>
  </div>

  <ng-template #notificationPassword>
    <div class="tw-flex tw-flex-col tw-gap-5 tw-px-8 tw-py-8">
      <ng-container *ngTemplateOutlet="importantNotePassword"></ng-container>
      <div
        class="tw-flex tw-justify-end tw-items-center tw-gap-4 xs:tw-flex-col-reverse xs:tw-items-stretch xs:tw-gap-3"
      >
        <button type="button" class="glass-dialog__cancel-btn" (click)="resetPassword()">
          {{ "setDifferentPassword" | i18n }}
        </button>
        <button type="button" class="glass-dialog__confirm-btn" (click)="submitStart()">
          {{ "confirmSignUp" | i18n }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
<div class="tw-max-w-xl tw-mx-auto tw-px-4 tw-py-2 tw-text-center sm:tw-flex-col">
  {{ "policyConfirmation" | i18n }}
  <a
    href="https://www.gloss-vault.com/privacy-policy"
    target="_blank"
    rel="noopener noreferrer"
    class="tw-underline tw-underline-offset-2"
  >
    {{ "privacyPolicyLink" | i18n }}
  </a>
</div>

<ng-template #importantNotePassword>
  <div class="tw-flex tw-flex-col tw-gap-6">
    <app-status-header
      [type]="'warning'"
      [title]="'importantNotePassword' | i18n"
    ></app-status-header>
    <p class="tw-text-sm tw-text-dt-text-secondary">
      {{ "importantNotePasswordDesc" | i18n }}
      <span class="tw-text-dt-text-warning"> {{ "cannotResetAccount" | i18n }} </span><br /><br />
      {{ "importantNotePasswordDesc2" | i18n }}<br /><br />
      {{ "importantNotePasswordDesc3" | i18n }}
    </p>
  </div>
</ng-template>
